import React, { useCallback, useContext } from 'react';

import { TrainingGroupDefinitionsContext } from '../../group-definitions.context';
import TrainingGroupForm from '../GroupDefinitionForm';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(TrainingGroupDefinitionsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <TrainingGroupForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
